import UserManage from './components/UserManage.vue';
import MediationGroups from './components/MediationGroups.vue';

export const routes = [
    {
        path: '/',
        redirect: {name: 'MediationGroups'},
    }, {
        name: 'MediationGroups',
        path: '/mediation-groups',
        component: MediationGroups,
    }, {
        name: 'UserManage',
        path: '/user',
        component: UserManage,
    },
]
